import { URLS } from "../../env/urls";
import { sendServerRequest } from "../../server/request";
import { Script1State } from "./types";
import { ScriptKey } from "./serverstates";

export async function updateChatFgtsChatState(chatId:number,state:Script1State){
    try{
       const r=await sendServerRequest('POST',URLS.fgtsChat.updateState,{chatId,state});
    }catch(e){
        throw e;
    }
}

/**
 * Muda o estado de um chat informando o script (1=FGTS, 2=CLT). Se o estado for
 * de outro script, o backend troca o script do chat junto.
 */
export async function updateChatState(chatId:number,state:string,script:ScriptKey){
    return await sendServerRequest('POST',URLS.fgtsChat.updateChatState,{chatId,state,script});
}

/** Gera a proposta do chat manualmente (script1=FGTS, script2=CLT). */
export async function generateChatProposal(chatId:number,script:ScriptKey){
    return await sendServerRequest('POST',URLS.fgtsChat.generateProposal,{chatId,script});
}